import APILibrary, { ClassExtender, GConstructor, GenerateResource } from './APILibrary';
import { GeographyResource } from './Geography';
import { CertificationOptionResource } from 'util/resources/CertificationOption';
import { Base, Collection } from 'active-resource';

/**
 * Relationship classes
 */
export class CertificationCategoryAttributes {
  id: string = null;
}

export class CertificationCategoryBelongsTo {
  geography: () => GeographyResource = () => new GeographyResource();
}

export class CertificationCategoryHasOne {}

export class CertificationCategoryHasMany {
  certificationOptions: () => Collection<CertificationOptionResource> = () =>
    new Collection<CertificationOptionResource>();
}

/**
 * Utility interfaces
 */
export interface CertificationCategoryMethods {}

export interface CertificationCategoryInterface
  extends CertificationCategoryAttributes,
    CertificationCategoryBelongsTo,
    CertificationCategoryHasMany,
    CertificationCategoryType {}

type CertificationCategoryType = GConstructor<CertificationCategoryInterface>;

export interface CertificationCategoryResource
  extends Base<CertificationCategoryAttributes>,
    CertificationCategoryInterface,
    CertificationCategoryMethods {}

/**
 * Resource methods
 */
const BaseClass = () =>
  GenerateResource<CertificationCategoryAttributes>({
    queryName: 'certification_categories',
    className: 'CertificationCategory',
    AttributesClass: CertificationCategoryAttributes,
    BelongsToClasses: [
      {
        Klass: CertificationCategoryBelongsTo,
      },
    ],
    HasManyClasses: [
      {
        Klass: CertificationCategoryHasMany,
      },
    ],
  });

export const CertificationCategoryResourceClass = <TBase extends CertificationCategoryType>(
  BaseConstructor: TBase,
): TBase => class extends BaseConstructor implements CertificationCategoryMethods {};

export class CertificationCategoryResource extends ClassExtender<CertificationCategoryInterface>(
  BaseClass,
  CertificationCategoryResourceClass,
) {}

/**
 * Resource instance
 */
export const CertificationCategory = APILibrary.createResource<CertificationCategoryResource>(
  CertificationCategoryResource,
);
